import { css, Theme } from "@emotion/react";

export const SelectCustomStyle = {
  self: ({ colors }: Theme) => css`
    & .ant-select {
      width: 100%;

      &-selector {
        height: 44px !important;
        background-color: transparent !important;
        border: 1px solid rgba(255, 219, 36, 0.3) !important;
        border-radius: 6px !important;
        outline: none !important;
        box-shadow: none !important;

        .ant-select-selection-placeholder {
          display: flex;
          align-items: center;
          color: ${colors.lightText};
          opacity: 0.6;
        }
      }

      &-selection-item {
        color: ${colors.lightText} !important;
        display: flex;
        align-items: center;
      }

      &-arrow {
        color: ${colors.lightText};
      }

      &-clear {
        background-color: unset !important;
        color: ${colors.lightText} !important;
      }

      &:hover .ant-select-selector {
        border-color: rgba(255, 219, 36, 0.5) !important;
      }

      &-focused .ant-select-selector {
        border-color: #ffdb24 !important;
      }

      // custom validate error
      &-status-error {
        .ant-select-selector {
          border: 1px solid var(--error-color) !important;
          .ant-select-selection-placeholder {
            opacity: 1;
            color: var(--error-color);
          }
        }
        .ant-select-arrow {
          color: var(--error-color);
        }
      }

      &-disabled {
        opacity: 0.5;
      }
    }
  `,
};

export const customSelectOverride = ({ colors }: Theme) => css`
  .ant-select-dropdown {
    background-color: ${colors.black100} !important;
    border: 1px solid rgba(255, 219, 36, 0.3) !important;
    border-radius: 6px !important;

    & .ant-select-item {
      padding: 8px 12px;
      min-height: 36px;
      border-radius: 4px;
      transition: all 0.2s;
      background-color: transparent !important;
      color: ${colors.lightText} !important;
      display: flex;
      align-items: center;

      &:not(:last-of-type) {
        margin-bottom: 2px;
      }

      &:not(.ant-select-item-option-disabled) {
        &:hover {
          background-color: rgba(255, 219, 36, 0.1) !important;
          color: ${colors.lightText} !important;
        }
      }

      &-option-selected {
        background-color: rgba(255, 219, 36, 0.15) !important;
        color: ${colors.lightText} !important;
      }

      &-option-disabled {
        opacity: 0.5;
      }
    }
  }
`;
